module.exports = __webpack_public_path__ + "img/deployment-attempts.48fe1ff0.png";